export const NESTING_PREFIX = '0xf8238ccfff8ed887463fd5e0'
export const COLLECTION_ADDRESS_PREFIX = '0x17c4e6453cc49aaaaeaca894e6d9683e'

export const WS_RPC = {
  unique: 'wss://eu-ws.unique.network',
  quartz: 'wss://quartz.unique.network',
  uniqueRC: 'wss://ws-rc.unique.network',
  opal: 'wss://opal.unique.network',
  polkadot: 'wss://rpc.polkadot.io',
  kusama: 'wss://quartz.api.onfinality.io/public-ws',
}
